export default {_name:'WebView',module:'Field',view:'Element/WebView',options:{key:'web'}}